import { render, staticRenderFns } from "./CatalogueArea.vue?vue&type=template&id=5a900570&"
import script from "./CatalogueArea.vue?vue&type=script&lang=js&"
export * from "./CatalogueArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports